import { FlexContainer, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import * as Styled from './styles';
import { icons } from './icons';

const PaymentMethods = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.PLANS);

  return (
    <FlexContainer align="center" direction="column" wrap="wrap">
      <Text type="fds_text_semibold_S" mb="fds_size_16">
        {t('Plans.paymentMethod.title')}
      </Text>
      <FlexContainer wrap="wrap" align="center" justify="center">
        {icons.map(icon => (
          <Styled.PaymentContainer key={icon.id}>{icon.component}</Styled.PaymentContainer>
        ))}
      </FlexContainer>
    </FlexContainer>
  );
};
export default PaymentMethods;
